import React, { Component } from "react";
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";

import Home from "./pages/Home";
import Products from "./pages/Products";
import Plastics from "./pages/Plastics";
import Metallics from "./pages/Metallics";
import About from "./pages/About";
import Career from "./pages/Career";
import Contact from "./pages/Contact";
import ProductDetails from "./pages/Product-details";
import ScrollToTop from "../ScrollToTop";

class Router extends Component {
  render() {
    return (
      <BrowserRouter>
      <ScrollToTop /> 
        <div className="page-wrapper">
          <Routes>
            <Route path="/" exact="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/historique" element={<Career />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/products" element={<Products />} />
            <Route path="/plastics" element={<Plastics />} />
            <Route path="/metallics" element={<Metallics />} />
            <Route path="/product-details/:id" element={<ProductDetails />} />
          </Routes>
        </div>
      </BrowserRouter>
    );
  }
}

export default Router;
